import { isServer, type QueryClient } from "@tanstack/react-query";
import { gameIndexQueryOptions } from "../game.queries";
import { gameIndexHead } from "./game-index-head";

export async function prepareGameIndex({
  queryClient,
  href,
}: {
  readonly queryClient: QueryClient;
  readonly href: string;
}) {
  const options = gameIndexQueryOptions(href);

  if (isServer) {
    const page = await queryClient.fetchQuery(options);
    return { head: gameIndexHead(page) };
  }

  void queryClient.prefetchQuery(options);

  return undefined;
}
